export enum OperationsEnum  {
  ADD_MEMBER= "ADD_MEMBER",
  REMOVE_MEMBER= "REMOVE_MEMBER",
  UPDATE_MEMBER= "UPDATE_MEMBER",
};
